import clientActions from "../../../actions/clientActions";
import clientTableColumns, {
  clientTableSummaries,
  clientTableLeftFixedColumns,
  clientSelectionOperations,
} from "./clientTableColumns";
import generateEntityTable from "../../../hocs/generateEntityTable";

const clientEditorRoutePath = "/client-edition";

const ClientsTable = generateEntityTable({
  entityPluralString: "clients",
  entityActions: clientActions,
  editorRoutePath: clientEditorRoutePath,
  columns: clientTableColumns,
  leftFixedColumns: clientTableLeftFixedColumns,
  summaries: clientTableSummaries,
  selectionOperations: clientSelectionOperations,
  enableSelection: true,
  walletBalancingOperation: true,
  walletBalancingRoutePath: "/client-wallet-balancing/:id",
  walletPositionOperation: true,
  walletPositionRoutePath: "/client-wallet-position/:id",
});

export default ClientsTable;
